// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__withLeftPad--eosIZ {
  padding-left: 24px;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__pageContent--KVuaI {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__tabs--_90Rq {
  padding-left: 24px;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__tabs--_90Rq .ant-tabs-nav::before {
  border: none;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__tabs--_90Rq .ant-tabs-tab {
  padding: 12px 0;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__tabContent--GKXzJ {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__entityContent--yzrXv {
  flex: 1;
  overflow: hidden;
  border-top: 1px solid #0000000f;
  background-color: #f5f5f5;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__newEntityContent--fX1ow {
  background-color: #f5f5f5;
  flex: 1;
  overflow: hidden;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__box--LySb3 {
  display: flex;
  flex-direction: column;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__item--J9LJB {
  border-left: thin solid rgba(0, 0, 0, 0.06);
  padding: 5px 0 5px 16px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__item--J9LJB.src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__active--heVmB {
  color: #e43d00;
  border-left-color: #e43d00;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityCardPage/EntityCardPage.module.less","webpack://./src/pages/EntityCardPage/EntityFormWithAnchor/EntityAnchor.module.less"],"names":[],"mappings":"AAKA;EACE,kBAAA;ACJF;ADOA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACLF;ADQA;EAVE,kBAAA;ACKF;ADSI;EACE,YAAA;ACPN;ADEA;EAUI,eAAA;ACTJ;ADaA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACXF;ADcA;EACE,OAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;ACZF;ADeA;EACE,yBAAA;EACA,OAAA;EACA,gBAAA;ACbF;AAhCA;EACE,aAAA;EACA,sBAAA;AAkCF;AAhCA;EACE,2CAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAkCF;AAhCE;EACE,cAAA;EACA,0BAAA;AAkCJ","sourcesContent":["// Конечно, было бы проще сделать отступ для всего контейнера\n// Но дизайн предполагает наличие горизонтальных черт от края до края\n// Поэтому приходится указывать отступ для всех вложенных элементов индивидуально.\n@leftPad: 24px;\n\n.withLeftPad {\n  padding-left: @leftPad;\n}\n\n.pageContent {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabs {\n  .withLeftPad();\n\n  :global(.ant-tabs-nav) {\n    &::before {\n      border: none;\n    }\n  }\n\n  :global(.ant-tabs-tab) {\n    padding: 12px 0;\n  }\n}\n\n.tabContent {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.entityContent {\n  flex: 1;\n  overflow: hidden;\n  border-top: 1px solid #0000000f;\n  background-color: #f5f5f5;\n}\n\n.newEntityContent {\n  background-color: #f5f5f5;\n  flex: 1;\n  overflow: hidden;\n}\n","@import \"../EntityCardPage.module.less\";\n\n.box {\n  display: flex;\n  flex-direction: column;\n}\n.item {\n  border-left: thin solid rgba(0, 0, 0, 0.06);\n  padding: 5px 0 5px 16px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n\n  &.active {\n    color: #e43d00;\n    border-left-color: #e43d00;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"withLeftPad": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__withLeftPad--eosIZ`,
	"pageContent": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__pageContent--KVuaI`,
	"tabs": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__tabs--_90Rq`,
	"tabContent": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__tabContent--GKXzJ`,
	"entityContent": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__entityContent--yzrXv`,
	"newEntityContent": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__newEntityContent--fX1ow`,
	"box": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__box--LySb3`,
	"item": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__item--J9LJB`,
	"active": `src-pages-EntityCardPage-EntityFormWithAnchor-EntityAnchor-module__active--heVmB`
};
export default ___CSS_LOADER_EXPORT___;
